import { ActionMenu } from '@portal/components'

type Props = {
  viewerCanDelete: boolean
  onSelectForInspection: () => void
  onSelectForDeletion: () => void
}

export default function ApiKeyActionMenu({
  viewerCanDelete,
  onSelectForInspection,
  onSelectForDeletion,
}: Props) {
  return (
    <ActionMenu
      items={[
        {
          label: 'Inspect API Key',
          onClick: onSelectForInspection,
          id: 'inspectKey',
        },
        ...(viewerCanDelete
          ? [
              {
                label: 'Delete API Key',
                onClick: onSelectForDeletion,
                id: 'deleteKey',
              },
            ]
          : []),
      ]}
      align="end"
    />
  )
}
